import React, { useState,useEffect } from "react";
import  "../../../css/style-new.css";
import  "../../../css/developer1.css";
import "../../../css/bootstrap.min.css";
import "../../../css/font.css";
import { Link, useNavigate, useParams } from 'react-router-dom'
import axios from "axios";
import { facultyposlistsc } from "../../../apis/urls";

const EditFacultyPosition = () => {

    const { id } = useParams();

    useEffect(() => {
        editlisting();
    },[]
    );

    const [res,setRes] = useState([]);
    const [name,setName] = useState('');
    const [description, setDescription] = useState('');
    const [status, setStatus] = useState('');
    const [nameerror,setNameerror] = useState('');
    const [publicvalue,setPublicvalue] = useState('');

    let navigate = useNavigate();
    const RoutToList = () =>{

        let path = 'newPath'; 
        navigate("/facultyposlist")
        
    }


    const editlisting = () => {
        let token = "Bearer "+localStorage.getItem('token');
        
        const instance = axios.create({

            baseURL: facultyposlistsc+id,

            timeout: 1000000,

            headers: {'authorization': token}

            });
            
            instance.get('').then((response) =>{
            
            setRes(response.data.data);
            //console.log(response.data.data.name)
            //console.log("name",res.name)
            setName(response.data.data.name);
            setDescription(response.data.data.description);
            setStatus(response.data.data.status);
            setPublicvalue(response.data.data.publicvalue);

           
            
            }).catch((error) =>{
            
            console.log('error',error.message)
            

            });
    }

    const onEditForm = () => {

        let error = 0;

        if(name === '')
        {
            setNameerror(true)
            error = 1;
        }

        if(error === 0) 
        {

            let token = "Bearer "+localStorage.getItem('token');
            
            const data = {
                name :name,
                description :description,
                status :status,
                public:publicvalue,
            }
            
            const instance = axios.create({

                baseURL: facultyposlistsc+id,

                timeout: 1000000,

                headers: {'authorization': token}

            });
            
            instance.put('',data).then((response) =>{
                
                
                navigate("/facultyposlist")
            
            }).catch((error) =>{
                
                console.log('error',error.message)

            
                

            });
        }
    }


    return(
        <div className="wrapper">
            <aside className="right-side ">
                <div className="content-area">
                    <div className="page-title-wrpr">
                        <div className="page-title-left-column">
                            
                            <h2 className="page-title">Edit Faculty Position</h2>
                        </div>
                        <div className="page-rightside-action-column">
                            
                            
                        </div>
                    
                    
                    </div>

                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb">
                            <li class="breadcrumb-item"><Link to="/dashboard">Home</Link></li>
                            <li className="breadcrumb-item"><Link to="/facultyposlist">Faculty positions</Link></li>
                            <li className="breadcrumb-item active" aria-current="page">Edit Faculty Position</li>
                        </ol>
                    </nav>

                    <form className="needs-validation" noValidate>
                        <div className="form-wrpr">
                            <div class="card formcard small">
                                <div class="card-body">
                                    <div class="form-group">
                                        <label className="degreehead">Position Name <span style={{color: "red"}}>*</span></label>
                                        <input type="text" class="form-control bg-dark dark-theme showtext" onChange={e => {setName(e.target.value)}} defaultValue={res.name} id="name"></input>
                                        {
                                            nameerror
                                            ? <div className="nerrors" style={{color:"red",fontSize: "12.8px"}}>Enter The Position</div>
                                            :null
                                        }
                                    </div>
                                    <div class="form-group">
                                        <label className="degreehead">Description</label>
                                        <input type="text" class="form-control bg-dark dark-theme showtext" onChange={e => {setDescription(e.target.value)}}  defaultValue={res.description} id="name"></input>
                                    </div>
                                    <div className="form-group">
                                        <label className="degreehead">Status <span style={{color: "red"}}>*</span></label>
                                        <select className="form-control bg-dark dark-theme showtext" onChange={e => {setStatus(e.target.value)}} id="status-selector">
                                        <option value="ACTIVE">Select Status</option>
                                        <option value="ACTIVE" selected = {res.status === 'ACTIVE'}>ACTIVE</option>
                                        <option value="INACTIVE" selected = {res.status === 'INACTIVE'}>INACTIVE</option>
                                        <option value="DELETED" selected = {res.status === 'DELETED'}>DELETED</option>
                                        </select>                        
                                    </div>
                                    <div className="form-group">
                                        <label className="degreehead">Show in directory <span style={{color: "red"}}>*</span></label>
                                        <select className="form-control bg-dark dark-theme showtext" onChange={e => {setPublicvalue(e.target.value)}} id="status-selector">
                                        
                                        <option value="NO" selected = {res.public === 'NO'}>NO</option>
                                        <option value="YES" selected = {res.public === 'YES'}>YES</option>
                                        
                                        </select>                        
                                    </div>
                                    <h6 style={{color: "red"}}>* Required Fields</h6>
                                    <div class="form-group text-right">
                                        <button className="btn btn-primary btn-gisa cancelbtn" onClick={RoutToList}>Cancel</button>
                                        <button onClick={onEditForm} className="btn btn-primary btn-gisa" type="button">Update</button>
                                    </div>
                                </div>
                            </div>
                            
                        </div>
                    </form>


                </div>
            </aside>
        </div>
    )
}

export default EditFacultyPosition;